var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#1E2228"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.25C11.1904 11.25 11.75 10.6904 11.75 10C11.75 9.30964 11.1904 8.75 10.5 8.75C9.80964 8.75 9.25 9.30964 9.25 10C9.25 10.6904 9.80964 11.25 10.5 11.25Z",
    fill: "#1E2228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.25C14.9404 11.25 15.5 10.6904 15.5 10C15.5 9.30964 14.9404 8.75 14.25 8.75C13.5596 8.75 13 9.30964 13 10C13 10.6904 13.5596 11.25 14.25 11.25Z",
    fill: "#1E2228"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 11.25C7.02336 11.25 7.58301 10.6904 7.58301 10C7.58301 9.30964 7.02336 8.75 6.33301 8.75C5.64265 8.75 5.08301 9.30964 5.08301 10C5.08301 10.6904 5.64265 11.25 6.33301 11.25Z",
    fill: "#1E2228"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.368554b55f209172012c9935c0ee8f13.svg";
export { ForwardRef as ReactComponent };